import React, { FC, ReactNode, useState } from 'react'
import { WalletModalContext } from './useWalletModal'
import { WalletModal, WalletModalProps } from './WalletModal'

export interface WalletModalProviderProps extends WalletModalProps {
  children: ReactNode
}

export const WalletModalProvider: FC<WalletModalProviderProps> = ({
  children,
  ...props
}) => {
  const [visible, setVisible] = useState(false)

  return (
    <WalletModalContext.Provider
      value={{
        visible,
        setVisible,
      }}
    >
      {children}
      {visible && <WalletModal {...props} />}
    </WalletModalContext.Provider>
  )
}
